import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SupplierGroupTemplateApi } from '../api/supplier-group-template.api';
import {
  SupplierGroupTemplate,
  SupplierGroupTemplateSave,
} from '../models/supplier-group-template.model';

@Injectable({ providedIn: 'root' })
export class SupplierGroupTemplateService {
  private readonly _api = inject(SupplierGroupTemplateApi);

  public getAll(): Observable<SupplierGroupTemplate[]> {
    return this._api.getAll();
  }

  public save(data: SupplierGroupTemplateSave): Observable<void> {
    return this._api.save(data);
  }
}
